<mat-icon class="svg-icon" [class]="svgIconClass" [svgIcon]="svgIcon" aria-hidden="false" aria-label="SVG icon"></mat-icon>